export default [
  {
    path: '/presaleInfo',
    name: 'presaleInfo',
    component: () => import(/* webpackChunkName: "presaleInfo" */ '../../views/other/PresaleInfoNew.vue'),
    meta: {
      title: '预约登记',
    },
  },
  {
    path: '/car/carDetail',
    name: 'carDetail',
    component: () => import(/* webpackChunkName: "carDetail" */ '../../views/car/CarDetail.vue'),
    meta: {
      title: '',
    },
  },
  {
    path: '/other/articleDetail',
    name: 'articleDetail',
    component: () => import(/* webpackChunkName: "ArticleDetail" */ '../../views/other/ArticleDetail.vue'),
    meta: {
      title: ' ',
    },
  },
  {
    path: '/other/answer',
    name: 'answer',
    component: () => import(/* webpackChunkName: "answer" */ '../../views/other/Answer.vue'),
    meta: {
      title: '问答详情',
    },
  },
  {
    path: '/other/appDownload',
    name: 'appDownload',
    component: () => import(/* webpackChunkName: "appDownload" */ '../../views/other/AppDownload.vue'),
    meta: {
      title: '恒驰App下载',
    },
  },
  {
    path: '/other/tjAppDownload',
    name: 'tjAppDownload',
    component: () => import(/* webpackChunkName: "tjAppDownload" */ '../../views/other/TjAppDownload.vue'),
    meta: {
      title: '恒驰天机App下载',
    },
  },
  {
    path: '/other/questions',
    name: 'questions',
    component: () => import(/* webpackChunkName: "questions" */ '../../views/other/Questions.vue'),
    meta: {
      title: '常见问题与帮助',
    },
  },
  {
    path: '/other/wenjuan',
    name: 'wenjuan',
    component: () => import(/* webpackChunkName: "wenjuan" */ '../../views/other/Wenjuan.vue'),
    meta: {
      title: '恒驰售后服务网点调研',
    },
  },
  {
    path: '/other/serviceSites',
    name: 'serviceSites',
    component: () => import(/* webpackChunkName: "wenjuan" */ '../../views/other/Wenjuan.vue'),
    meta: {
      title: '售后服务网点',
    },
  },
  {
    path: '/other/inquiry',
    name: 'inquiry',
    component: () => import(/* webpackChunkName: "inquiry" */ '../../views/other/Inquiry.vue'),
    meta: {
      title: '意向征询',
    },
  },
  {
    path: '/other/feedback',
    name: 'feedback',
    component: () => import(/* webpackChunkName: "feedback" */ '../../views/other/Feedback.vue'),
    meta: {
      title: '意见反馈',
    },
  },
  // {
  //   path: '/other/festival',
  //   name: 'festival',
  //   component: () => import(/* webpackChunkName: "festival" */ '../../views/other/festival/720.vue'),
  //   meta: {
  //     title: '720购车节',
  //   },
  // },
  {
    path: '/contractSign/index',
    name: 'contractSign',
    component: () => import(/* webpackChunkName: "ContractSign" */ '../../views/contractSign/index.vue'),
    meta: {
      title: '',
    },
  },
  {
    path: '/edas',
    name: 'edasXieYi',
    component: () => import(/* webpackChunkName: "EdasXieYi" */ '../../views/other/EdasXieyi'),
    meta: {
      title: '',
    },
  },
  {
    path: '/other/bluetoothShare',
    name: 'bluetoothShare',
    component: () => import(/* webpackChunkName: "bluetoothShare" */ '../../views/other/BluetoothShare'),
    meta: {
      title: '',
    },
  },
]
